import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { useI18n } from '~Hooks';

const Wrapper = styled.div`
  margin-bottom: 64px;
`;

const Subtitle = styled.div`
  font-size: 24px;
  color: #fff;
  font-weight: 300;
`;

interface Props {
  cardNumber: string;
  setCardNumber: (value: React.SetStateAction<string>) => void;
}

export const SwipeView = ({ cardNumber, setCardNumber }: Props) => {
  const { i18n } = useI18n();

  useEffect(() => {
    /* This will be triggered when a key is pressed = the gift card is swiped */
    const onKeyPress = (input: KeyboardEvent) => {
      setCardNumber((state: string) => state + input.key);
    };

    document.addEventListener('keypress', onKeyPress);

    return () => document.removeEventListener('keypress', onKeyPress);
  }, []);

  return (
    <Wrapper>
      <Subtitle>
        {cardNumber.length === 0 ? i18n('GC.WaitForInput') : i18n('GC.Receiving')}
      </Subtitle>
    </Wrapper>
  );
};
